import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Attendance from "@/pages/Attendance";
import Fees from "@/pages/Fees";
import Checkout from "@/pages/Checkout";
import PaymentStatus from "@/pages/PaymentStatus";
import Circulars from "@/pages/Circulars";
import Result from "@/pages/Result";
import Timetable from "@/pages/Timetable";
import ExamSchedule from "@/pages/ExamSchedule";
import Syllabus from "@/pages/Syllabus";
import Homework from "@/pages/Homework";
import CalendarPage from "@/pages/CalendarPage";
import ConsentForms from "@/pages/ConsentForms";
import Remarks from "@/pages/Remarks";
import ChangeOfInformation from "@/pages/ChangeOfInformation";
import ApplyLeave from "@/pages/ApplyLeave";
import Notifications from "@/pages/Notifications";
import StudentData from "@/pages/StudentData";
import TeacherData from "@/pages/TeacherData";
import EditHomepage from "@/pages/EditHomepage";
import { Toaster } from "@/components/ui/sonner";

function RequireAuth({ children }) {
  const user = JSON.parse(localStorage.getItem("eis_user") || "null");
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

const AUTH_ROUTES = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/profile", element: <Profile /> },
  { path: "/attendance", element: <Attendance /> },
  { path: "/fees", element: <Fees /> },
  { path: "/checkout", element: <Checkout /> },
  { path: "/payment-status", element: <PaymentStatus /> },
  { path: "/circulars", element: <Circulars /> },
  { path: "/result", element: <Result /> },
  { path: "/timetable", element: <Timetable /> },
  { path: "/exam-schedule", element: <ExamSchedule /> },
  { path: "/syllabus", element: <Syllabus /> },
  { path: "/homework", element: <Homework /> },
  { path: "/calendar", element: <CalendarPage /> },
  { path: "/consent-forms", element: <ConsentForms /> },
  { path: "/remarks", element: <Remarks /> },
  { path: "/change-of-information", element: <ChangeOfInformation /> },
  { path: "/apply-leave", element: <ApplyLeave /> },
  { path: "/notifications", element: <Notifications /> },
  { path: "/student-data", element: <StudentData /> },
  { path: "/teacher-data", element: <TeacherData /> },
  { path: "/edit-homepage", element: <EditHomepage /> },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          {AUTH_ROUTES.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<RequireAuth>{element}</RequireAuth>}
            />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
